import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientSpecialtyEntity } from './client-specialty.entity';

@Index('specialty_pk', ['name'], { unique: true })
@Entity('specialty')
export class SpecialtyEntity extends BaseEntity {
	@Column('varchar', { name: 'name', unique: true, length: 255 })
	public name!: string;

	@Column('varchar', { name: 'externalId', nullable: true, length: 255 })
	public externalId!: string | null;

	@OneToMany(
		() => ClientSpecialtyEntity,
		(clientSpecialty) => clientSpecialty.fkSpecialty,
		{},
	)
	public clientSpecialties!: Array<ClientSpecialtyEntity>;
}
